"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var config = {
  urls: {
    monacoLoader: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.18.1/min/vs/loader.js',
    monacoBase: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.18.1/min/vs'
  }
};
var _default = config;
exports["default"] = _default;